<script lang="ts">
	import { browser } from '$app/environment';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			widget_id: string;
			iframe_props?: string;
			hidden?: string;
			loading_height?: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<svelte:head>
	{#if browser && !document.querySelector('script[src="//embed.typeform.com/next/embed.js"]')}
		<script async src="//embed.typeform.com/next/embed.js"></script>
	{/if}
</svelte:head>

<div
	data-tf-widget={content.widget_id}
	data-tf-opacity="100"
	data-tf-hide-headers
	data-tf-iframe-props={content.iframe_props}
	data-tf-disable-scroll
	data-tf-auto-resize
	data-tf-hidden={content.hidden}
	style="height:{content.loading_height ?? '100%'}; max-height: 100%"
></div>
